var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.isLoading),expression:"isLoading"}],staticClass:"iframe-container",attrs:{"element-loading-text":"Loading...","element-loading-spinner":"el-icon-loading"}},[_c('iframe',{staticClass:"heightClass",attrs:{"src":_vm.getSourceLink,"width":"100%"},on:{"load":_vm.iframeLoaded}})])
}
var staticRenderFns = []

export { render, staticRenderFns }